module.exports = __webpack_public_path__ + "img/icon-channel-handsup.66eb7df0.png";